import { Field } from 'formol'

export default Field
